export { default as Shop } from './Shop/Shop';
export { default as Quests } from './Quests/Quests';
export { default as Tournament } from './Tournaments/Tournament/Tournament';
export { Faq } from './Faq';
export { Help } from './Help';
export { Home } from './Home';
export { Profile } from './Profile';
export { Tournaments } from './Tournaments';
export { Welcome } from './Welcome';
export { Cybermarathon } from './Cybermarathon';